import React from "react";

interface PreviewBannerProps {
  status: string | undefined;
  /** Anchor link to the pricing section on this page, e.g. "#pricing" */
  pricingHref?: string;
}

/**
 * Shown when the client's site is in "trial" state (not yet an active subscriber).
 * Appears as a sticky top bar so prospects see it on the preview site.
 * Disappears once status === "active".
 */
export function PreviewBanner({ status, pricingHref = "/pricing" }: PreviewBannerProps) {
  if (status === "active") return null;

  return (
    <div
      className="sticky top-0 z-50 w-full bg-primary text-primary-foreground text-sm py-2 px-4 flex items-center justify-center gap-3"
      role="banner"
    >
      <span className="opacity-90">
        You're viewing a preview site — not yet live on a custom domain.
      </span>
      <a
        href={pricingHref}
        className="font-semibold underline underline-offset-2 hover:opacity-75 transition-opacity whitespace-nowrap"
      >
        Choose a plan →
      </a>
    </div>
  );
}
